import {
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

@Directive({ selector: '[splitInfiniteScroll]' })
export class SplitInfiniteScrollDirective implements OnInit, OnChanges, OnDestroy {
  @Input() splitInfiniteScrollDisabled = false;
  @Output() readonly scrolled = new EventEmitter<void>();

  private observer: IntersectionObserver | null = null;

  constructor(private readonly el: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !this.splitInfiniteScrollDisabled) {
          this.scrolled.emit();
        }
      },
      { threshold: 0.1 }
    );
    this.observer.observe(this.el.nativeElement);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['splitInfiniteScrollDisabled'] &&
      !this.splitInfiniteScrollDisabled &&
      this.observer
    ) {
      // Re-observe so IntersectionObserver fires immediately if element is still in viewport
      this.observer.unobserve(this.el.nativeElement);
      this.observer.observe(this.el.nativeElement);
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
